import { TEACHING_INDEX } from './teaching/index';
import { LIFE_INDEX } from './life/index';
import { DAILYOFFICE_INDEX } from './dailyoffice/index';
import { RESEARCH_INDEX } from './research/index';
import { FINANCE_INDEX } from './finance/index';
import { PERSONNEL_INDEX } from './personnel/index';

export const APPLICATION_INDEX = [
  DAILYOFFICE_INDEX,
  TEACHING_INDEX,
  LIFE_INDEX,
  RESEARCH_INDEX,
  FINANCE_INDEX,
  PERSONNEL_INDEX
];


// WEBPACK FOOTER //
// ./src/pages/application/index.ts